import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  highlight?: string;
  subtitle?: string;
  align?: 'center' | 'left';
};
export function SectionHeading({
  eyebrow,
  title,
  highlight,
  subtitle,
  align = 'center'
}: SectionHeadingProps) {
  const alignment = align === 'center' ? 'text-center mx-auto' : 'text-left';
  return <div className={`max-w-3xl ${alignment}`} data-id="element-157" data-mp="3k29jk5a4u4yr">
      {eyebrow && <p className="mb-2 text-xs font-bold tracking-[0.2em] text-lime-400 sm:text-sm" data-id="element-158" data-mp="blohz9jtye5o">
          {eyebrow}
        </p>}
      <h2 className="text-2xl font-extrabold leading-[1.1] tracking-tight text-white sm:text-3xl md:text-4xl" data-id="element-159" data-mp="glj99e7ip5r9">
        {title}
        {highlight && <span className="text-lime-400" data-id="element-160" data-mp="6t540bh8dh0c"> {highlight}</span>}
      </h2>
      {subtitle && <p className="mt-3 text-sm leading-relaxed text-white/60 sm:text-base" data-id="element-161" data-mp="ujhkwbugeo32">{subtitle}</p>}
    </div>;
}